<template>
  <Modal title="Общее время смен" @backdrop-click="close">
    <template slot="body">
      <div class="body__timepickers">
        <div
          v-for="timeType in timepickerTypes"
          :key="timeType"
          class="timepickers__wrapper timepickers__elem"
        >
          <span>{{ getTitle(timeType) }}</span>
          <DatePicker
            :popup-style="popupStyles"
            value-type="HH:mm"
            type="time"
            format="HH:mm"
            confirm-text="Установить"
            v-model="globalTime[timeType]"
            :clearable="false"
            :disabled-time="notAfterTenHoursPM"
            @confirm="(value) => globalTime[timeType] = value"
            confirm
          />
        </div>
      </div>
      <div v-if="listNotEmpty">
        <Checkbox
          label-text="Перезаписать уже добавленные значения"
          v-model="rewriteAll"
        />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            type="button"
            class="btn btn-danger buttons__button_close-modal"
            @click="close"
          >
            Отменить
          </button>
        </div>
        <div>
          <button
            class="btn btn-default btn-success"
            type="button"
            @click="save"
          >
            Установить
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatePicker from "vue2-datepicker";
import Modal from "@/_shared/components/ui/Modal";
import Checkbox from '@/_shared/components/ui/Checkbox';
import { useTimepickers } from "@/user/mixins/shifts-calendar";
import { objectHelper } from '@/_shared/utils';
export default {
  mixins: [useTimepickers],
  emits: ['close', 'save'],
  components: {
    DatePicker,
    Modal,
    Checkbox,
  },
  props: {
    listNotEmpty: {
      type: Boolean,
      default: false,
    },
    initTime: {
      type: Object,
      default() {
        return {
          start: '',
          end: '',
        }
      },
    },
  },
  data() {
    return {
      globalTime: objectHelper.createCopy(this.initTime),
      rewriteAll: false,
    };
  },
  mounted() {
    document.querySelector('body').style.overflow = 'hidden';
  },
  computed: {
    popupStyles() {
      return {
        zIndex: 1000000,
      };
    },
  },
  methods: {
    save() {
      this.$emit('save', this.globalTime, this.rewriteAll);
      this.close();
    },
    close() {
      document.querySelector('body').style.overflow = 'auto';
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.body__timepickers,
.timepickers__wrapper {
  display: inline-flex;
  flex-direction: column;
}
.timepickers__elem .mx-datepicker {
  width: 100%;
  padding-bottom: 1em;
}
@media (max-width: 419px) {
  .modal__buttons {
    flex-direction: column;
  }
  .buttons__button_close-modal {
    margin-bottom: 1em;
  }
  .modal__buttons > div > button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/components/shifts-calendar/GlobalTimeModal.vue